<template>
  <div class="download-container">
    <div class="top">
      <div class="cloud">
        <img src="~@/assets/h5/cloud@2x.png"
             alt="">
      </div>
    </div>
    <div class="middle">
      <div class="logo">
        <img src="~@/assets/h5/logo@2x.png"
             alt="">
      </div>
      <div class="logo_bar">
        <img src="~@/assets/h5/logo_bar@3x.png"
             alt="">
      </div>
      <div class="button">
        <div class="btn android" @click="download('android')">
          <icon style="font-size: 16px;vertical-align: middle;"
                name="android" />
          Android 下载
        </div>
        <div class="btn iphone" @click="download('ios')">
          <icon style="font-size: 16px;"
                name="iphone" /> iPhone 下载</div>
      </div>
    </div>
    <div class="bottom">
      <div class="totem">
        <img src="~@/assets/h5/totem@2x.png"
             alt="">
      </div>
      <!-- <div class="mountain">
        <img src="~@/assets/h5/mountain@2x.png" alt="">
      </div> -->
    </div>

    <div class="tt-mask"
         v-if="showTutorialArrow"
         @click="touch">
      <div class="tutorial-arrow">
        <img src="~@/assets/ios-tutorial-arrow.png"
             alt="">
        <div class="tuto__txt">点击右上角选择在浏览器中打开</div>
      </div>
    </div>
  </div>
</template> 

<script> 
import utils from '@/modules/utils'
export default {
  data () {
    return {
      showTutorialArrow: false
    }
  },
  computed: {
    isIos () {
      return utils.isIos
    },
    isAndroid () {
      return utils.isAndroid
    },
    isSafari () {
      return this.isIos && /safari/ig.test(navigator.userAgent)
    },
    isWeiXin () {
      return utils.isWeiXin()
    }
  },
  methods: {
    download (type) {
      if (this.isWeiXin) {
        this.showTutorialArrow = true
        return
      } 
      if (this.isSafari && type == 'ios') {
        let url = `itms-apps://itunes.apple.com/WebObjects/MZStore.woa/wa/viewSoftware?id=1524250809`
        // let url = `https://ios.ixex.io`
        window.location.href = url 
        return
      }

      if (type == 'android') {
        let url = 'https://upgrade-app.oss-cn-hangzhou.aliyuncs.com/qimenpan/qimen.apk'
        // window.open(url, '_blank')
        window.location.href = url 
      } 
    },
    touch () {
      this.showTutorialArrow = false
    }
  },
  created () {
     
  }
}
</script>

<style lang="scss">
@media (max-width: 800px) {
  html {
    font-size: 13.3333vw;
  }
  html,
  body {
    height: 100%;
  }
  .download-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    background-image: url(../assets/h5/bg@2x.jpg);
    background-size: 100% 100%;
    text-align: center;
    .top {
      flex: 0 0 auto;
      .cloud {
        text-align: left;
        img {
          width: 60%;
        }
      }
    }
    .middle {
      flex: 1 0 auto;
      .logo {
        img {
          width: 1.65rem;
          vertical-align: bottom;
        }
      }
      .logo_bar {
        height: 0.8rem;
        img {
          width: 2.01rem;
        }
      }
      .button {
        margin: 1.2rem auto 0.8rem;
        .btn {
          margin: 0 auto;
          width: 3.75rem;
          height: 0.88rem;
          background: url(../assets/h5/button@2x.png) top left/100% 100%
            no-repeat;
          font-size: 0.3rem;
          line-height: 0.88rem;
          color: #fff;
        }
        .android {
          margin-bottom: 0.4rem;
        }
      }
    }
    .bottom {
      flex: 1 0 auto;
      height: 3.65rem;
      background: url(../assets/h5//mountain@2x.png) top left/100% 100%;
      .totem {
        img {
          vertical-align: top;
          width: 3.04rem;
        }
      }
    }
  }
}
.tt-mask {
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);

  .tutorial-arrow { 
    position: absolute;
    right: 0.5rem;
    top: 0;
    text-align: right;
    img {
      width: 50%;
      height: 50%;
    }
    .tuto__txt {
      position: absolute;
      left: -0rem;
      bottom: -0.2rem;
      color: #fff;
      width: 4rem;
      text-align: center;
      font-size: 0.28rem;
      line-height: 1.2;
    }
  }
}
</style>